const lorryCreationForm = {
    id: "lorryForm",
    fields: {
        lorryNum: "lorryNum",
        lorryType: "lorryType",
        lorryCapacity: "lorryCapacity",
        lorryTyres: "lorryTyres",
        lorrySize: "lorrySize",
        lorryBodyType: "lorryBodyType",
        routeIds: "routeIds",
        selectedRouteIds: "selectedRouteIds",
        currentPlaceID: "currentPlaceID",
        currentCity: "currentCity",
        lorryId: "lorryId"
    }
};

export { lorryCreationForm };
//# sourceMappingURL=FormModels.js.map
